<template>
  <div class="runtime-topic-pk" :style="{background:`url(${backgroundImg.topicTemplateBackgroundUrl}) 0% 0% / 100% 100% no-repeat`}">
      <login-in :loginType="loginType"
        :isLoginFlag="isLoginFlag" 
        :activityTypeFlag="activityTypeFlag" 
        :activityUrl="activityUrl"></login-in>
      <!-- 内容 -->
      <div class="content">
        <!-- 标题 -->
        <div class="content-title">
            <span>{{ formCustom.activityName }}</span>
        </div>
        <!-- 活动时间 -->
        <div class="content-time">
            <div class="time">
                <span>活动时间：{{ formShow.activityStartTime + ' - ' + formShow.activityEndTime }}</span>
            </div>
            <!--微信hihonor小程序内且是启用分享且是分享抽奖且是进行中活动才显示-->
            <div v-if="loginType === 'wechat' && formCustom.shareFlag === '1'" class="share" @click="openGuide()">
                <img src="../../../../static/image/分享.png" alt="">
                <span style="color:#315DD2">分享</span>
            </div>
        </div>
        <van-divider
            :style="{ margin: 2 }"></van-divider>
        <!-- 活动内容 -->
        <div class="content-text">
            <span>{{ formShow.topicDesc }}</span>
        </div>
        <div v-if="!isChosen" class="content-support">
            <!-- 站队同意 -->
            <div :class="setClassLeft" 
                :style="{'background-color': disabled ? '#C3C3C3' : `${colorLeft}`,'box-shadow': disabled ? '0px 0px 8px 0px #C3C3C3' :`0px 0px 8px 0px ${colorLeft}`}"
                @click="leftClickHandler">
                <div class="left-content">
                    <div class="left-top">
                        <van-icon name="good-job" 
                            color="white" 
                            size="20" />
                    </div>
                    <div v-if="disabled" class="left-bottom">
                        <span class="left-bottom-text" :style="{'color': '#FFFFFF'}">{{ "已结束" }}</span>
                    </div>
                </div>
            </div>
            <div class="support-content">
                <div class="support-content-top">
                    <div class="percent-left">
                        <span :style="{'color':`${colorLeft}`}">{{formShow.willRatio + "%"}}</span>
                    </div>
                    <div>
                        <span class="PK" :style="{'color':`${colorLeft}`,'margin-right':'-5px'}">P</span>
                        <span class="PK" :style="{'color':`${colorRight}`}">K</span>
                    </div>
                    <div class="percent-right">
                        <span :style="{'color':`${colorRight}`}">{{ (100 - formShow.willRatio) + "%" }}</span>
                    </div>
                </div> 
                <van-progress style="width:100%;border-radius:20px;height:20%" 
                    :percentage="formShow.willRatio" 
                    :track-color="colorRight"
                    :color="colorLeft" 
                    stroke-width="15" 
                    :show-pivot="false" />
            </div>
            <!-- 站队反对 -->
            <div :class="setClassRight" 
                :style="{'background-color': disabled ? '#C3C3C3' : `${colorRight}`,'box-shadow': disabled ? '0px 0px 8px 0px #C3C3C3' :`0px 0px 8px 0px ${colorRight}`}"
                @click="rightClickHandler">
                <div class="right-content">
                    <div class="right-top">
                        <van-icon name="good-job" 
                            color="white" 
                            size="20" />
                    </div>
                    <div v-if="disabled" class="right-bottom">
                        <span class="right-bottom-text" :style="{'color': '#FFFFFF'}">{{ "已结束" }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 您已站队 --> 
        <div v-if="isChosen" class="chosen-side" :style="{'background-color':`${colorChosen}`}">
            <div class="container">
                <span class="stand-team">{{"您已站队“" + chooseSide + "”"}}</span>
                <div  v-if="buttonShow" class="button">
                    <van-button color="#F1F7FF" round
                        :style="{'color':`${colorChosen}`}"
                        @click="goNextActivityFn">
                        <span :style="{'font-color':`${colorLeft}`}">去抽奖</span>
                    </van-button>
                </div>
                <span class="support-percent">{{ "支持率" + ratioChosen + "%" }}</span>
            </div>
        </div>
        <!-- 参与活动总人数 -->
        <div v-if="isChosen" class="totalNum">
            <span>{{ "共" + formShow.totalNum + "人参与话题" }}</span>
        </div>
        <!-- 头像 -->
        <div v-if="!isChosen" class="content-avatar"> 
            <div class="left-container">
                <div class="avatar-left">
                    <div v-for="(item,i) in willUserHeadImgURl" :key="i"
                        style="margin-right:-0.48rem">
                        <van-image
                            round
                            width="1.45rem"
                            height="1.45rem"
                            :src="item"
                        />
                    </div>
                </div>
                <div class="text-left">
                    <span>{{ formShow.willNum + "人站队" }}</span>
                    <span>{{ "“" + formShow.leftOfficialContent + "”" }}</span>
                </div>
            </div>
            <div class="right-container">
                <div class="avatar-right">
                    <div v-for="(item,i) in unWillUserHeadImgURl" :key="i"
                        style="margin-right:-0.48rem">
                        <van-image
                            round
                            width="1.45rem"
                            height="1.45rem"
                            :src="item"
                        />
                    </div>
                </div>
                <div class="text-right">
                    <span>{{ formShow.unWillNum + "人站队" }}</span>
                    <span>{{ "“" + formShow.rightOfficialContent + "”" }}</span>
                </div>
            </div>
        </div>
        <!-- 活动规则按钮 -->
        <div v-if="activityRulesVisible" 
            class="activity-rules-area" 
            @click="showActivityRules">
            活动规则
        </div>
      </div> 
      <!-- 站队弹窗 -->
      <van-popup v-model="show" class="dialog" 
        closeable
        :transition-appear="true"
        transition="fade"
        duration="1"
        close-icon="close"
        :style="{background: `url(${backgroundImg.topicTemplatePopUpUrl})`,'background-repeat':'no-repeat','background-size':'100% 40%','background-color':'#FFFFFF'}">
        <div class="dialog-content">
            <div class="content-top">
                <span>{{"您已站队“"}}</span>
                <span style="font-weight: 700">{{chooseSide}}</span>
                <span>{{"”"}}</span>
            </div>
            <div class="content-middle">
                <div class="dialog-avatar">
                    <div v-for="(item,i) in imgList" :key="i"
                        style="margin-right:-0.48rem">
                        <van-image
                            round
                            width="2.45rem"
                            height="2.45rem"
                            :src="item"
                        />
                    </div>
                </div>
                <span style="text-align:center">{{ sideNum + "人站队“" + chooseSide + "”" }}</span>
            </div>
            
            <div v-if="buttonShow" class="content-bottom">
                <div class="v-button">
                    <van-button round color="#315DD2" @click="goNextActivityFn">
                        <span style="font-size:16px">去抽奖</span>
                    </van-button>
                </div>
            </div>
            <div v-if="loginType === 'wechat' && formCustom.shareFlag === '1'" class="share" @click="openGuide()">
                <img src="../../../../static/image/分享.png" alt="">
                <span style="color:#315DD2">分享</span>
            </div>
        </div>
      </van-popup>
      <!-- 活动结束弹窗 -->
      <van-popup v-model="showEnd" class="dialogEnd" 
        closeable
        close-icon="close">
        <div class="endTitle">
            <span>活动已结束</span>
        </div>
        <div class="endImage">
            <img src="../../../../static/image/已结束.png" alt="">
        </div>
        <div class="activityTime">
            <span>{{ "尊敬的用户，本次活动已结束!" }}</span><br/>
            <span>{{ "请关注我们的后续活动" }}</span>
        </div>
      </van-popup>
      <!-- 页脚 -->
      <div class="footer">
        <span>最终解释权归荣耀终端股份有限公司所有</span>
      </div>
      <!-- 活动未开始 -->
      <div v-if="showNoStart" class="noStart">
        <div class="top">
            <span>活动未开始</span>
        </div>
        <div class="middle">
            <img src="../../../../static/image/未开始.png" alt="">
        </div>
        <div class="bottom">
            <span>{{ "尊敬的用户，本次活动未开始!" }}</span>
            <span>{{ "请于" + formShow.activityStartTimePop + "参与活动"}}</span>
        </div>
      </div>
      <guideModal ref="guideModal" :isWechat="!miniprogramFlag && loginType === 'wechat'"></guideModal>
      <!-- 活动规则弹窗 -->
      <activity-rules ref="activityRulesRef" :rule-desc="ruleDesci"></activity-rules>
      <IncorrectClient :isDisplay="!isCorrectClient" :loginType="originLoginType"></IncorrectClient>
  </div>
</template>

<script>
import { Progress, Icon, Image as VanImage, Button, Popup, Toast, Divider   } from 'vant';
import wx from "weixin-js-sdk";
import 'animate.css';
import guideModal from "./dynamicAttr/modal/guideModal";
import loginIn from './dynamicAttr/modal/login-in.vue';
import comUtils, { loadAlipayWebViewScript } from '../../../utils/comUtils';
import activityRules from './topicPK/activity-rules.vue';
import IncorrectClient from "./dynamicAttr/incorrect-client.vue";
import { BigWheelConstants as BWC, CustomFormConstants as CFS } from './lucky-draw/common/global-variable';
import { noLoginHandler, checkClient } from './common-methods/utils';
export default {
    components: {
        [Progress.name]:  Progress,
        [Icon.name]:  Icon,
        [VanImage.name]:  VanImage,
        [Button.name]:  Button,
        [Popup.name]:  Popup,
        [Divider.name]:  Divider,
        guideModal,
        loginIn,
        activityRules,
        IncorrectClient
    },
    data() {
        return {
            answer: [],
            setClassLeft: "support-left",
            setClassRight: "support-right",
            show: false,
            showEnd: false,
            showNoStart: false,
            disabled: false,
            isDisabled: false,
            isChosen: false,
            chooseSide: "",
            colorChosen: "",
            ratioChosen: "",
            colorLeft: "",
            colorRight: "",
            wordColor: "",
            imgList: [],
            buttonShow: false,
            nextActivity: "",
            side: "",
            sideNum: "",
            backgroundImg:{
                topicTemplateBackgroundUrl: "",
                topicTemplatePopUpUrl: "",
            },
            unWillUserHeadImgURl: [],//反对者头像
            willUserHeadImgURl: [],//支持者头像
            activityCode: "",//活动编码
            formCustom: {},//表单信息
            formShow: {
                topicDesc: "",
                leftOfficialContent:"",
                rightOfficialContent:"",
                activityEndTime:"",
                activityStartTime:"",
                activityEndTimePop:"",
                activityStartTimePop:"",
                unWillNum:"",
                willNum:"",
                totalNum:"",
                willRatio:"",
                unWillRatio:"",
                willUserHeadImgURl:[],
                unWillUserHeadImgURl:[],
            },//数据处理信息
            loginType:"",//登录方式
            miniprogramFlag: false, //判断是否在小程序环境内打开
            activityUrl: '', // 当前活动地址
            isLoginFlag:false, // 默认没有登录
            activityTypeFlag:'', // 小程序类型：1体验店（hi荣耀），2直营店
            activityRules: '',
            automaticLottery: '', // 自动开奖是否开启
            bigWheelActivityType: '', // 下级抽奖活动的样式类型
            noAsk: false,  // 授权通知抽奖消息时，用户是否选择了“不再询问”
            isCorrectClient: true, // 是否在正确的客户端打开
            originLoginType: '', // 原始登录类型（转换前）
            positionInfo:{}
        }
    },
    computed: {
        activityRulesVisible() {
            return this.activityRules.trim().length > 0;
        },
        ruleDesci() {
            if (this.activityRules.indexOf("<a href=") != -1) {
                this.activityRules = this.activityRules.replace(
                /<a [^>]*href=['"]([^'"]+)[^>]*>/g,
                function(match, capture) {
                    const result = capture;
                    return (
                    "<a href=" +
                    result +
                    ' rel="noopener noreferrer" target="_blank">'
                    );
                }
                );
            }
            return this.activityRules
                .replace(/↵/g, "<br/>")
                .replace(/\n/g, "<br/>")
                .replace(/ihlp/g, "hd");
        },
    },
    created(){
        this.loginType = sessionStorage.getItem("loginType") || "";
        const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
        console.log('loginType',this.loginType);
        // 判断是否在小程序内
        this.handleMiniprogramJudge();
        console.log('miniprogramFlag',this.miniprogramFlag);

        this.activityTypeFlag = sessionStorage.getItem('activityTypeFlag') || '';
        const code = this.$route.query && this.$route.query.activityCode;
        this.activityCode = code;
        // 组装当前地址
        this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + code;
        if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
      this.activityUrl =
        this.activityUrl +
        '&ay=' +
        eventTrackingData.activityType +
        '&GUID=' +
        eventTrackingData.guideUserId +
        '&SC=' +
        eventTrackingData.storeCode;
    }
        this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === "true" ? true : false;
        this.initFormData(); //初始化
    },
    mounted(){
        this.originLoginType = sessionStorage.getItem("originLoginType");
        this.isCorrectClient = checkClient(this.originLoginType);
    },
    methods:{
        //站队接口
        chooseSideFn(side) {
            let userBase = {};
            let userInfo = sessionStorage.getItem('userInfo');
            if(userInfo){
                userInfo = JSON.parse(userInfo);
                userBase = Object.assign(userBase, userInfo);
            }
            //获取微信用户信息
            this.formCustom = Object.assign(this.formCustom, userBase);
            this.formCustom.userOpenid = userBase.openId || '';   //oWtAW0fVA5Rwl8lYrHLnnsJqgufE
            this.formCustom.userUnionid = userBase.unionid || '';  //o93zEwzIjTJR1a_3X4_UEz7ct4Co
            this.formCustom.userGender = userBase.sex === 1 || userBase.gender === "m" ? '1' : '2';
            this.formCustom.nickName = userBase.nickName;
            this.formCustom.headimgurl = userBase.headimgurl;
            this.formCustom.alipayUserId = sessionStorage.getItem('alipayUserId') || "";
            const params = this.formCustom
            params.questionList[0].answerContent = side ? "0" : "1";
            params.activityCode = this.activityCode;
            const extendConfig = this.$utils.getStorageItemObj("extendConfig");
            params.times = extendConfig.times;
            if(sessionStorage.getItem("connectionId")){
                params.connectionId = sessionStorage.getItem("connectionId");
            }
            if(!sessionStorage.getItem('alipayUserId')) {
                // 支付宝已经是隐私结构体了
                const  privacyKeys =  {
                    nickName: '$PrivacyPlain$',
                }
                //隐私信息保存
                const privacyKeyLsit = [
                    {
                        nickName: 'nickName',
                        typeText: 'NICK_NAME',
                        labelText: 'mktStudentRewardRecodeNickName'
                    },
                ];
                this.$utils.privacySave(privacyKeys, privacyKeyLsit, params);
            }
            const self = this;
            self.$api.post({
                noLoading: true,
                sc: "mobileMarketingH5",
                params:params,
                url: "questionActivity/editQuestionAnswer",
                success: r => {
                if( r.code === 200 ) {
                    if(r.result){
                        if( r.result.connectionId ) sessionStorage.setItem("connectionId", r.result.connectionId);
                    }
                    const result =  r.result || {};
                    if( result.insertFlag ) {
                        self.isCutoff = true;
                        self.submitDocument = '活动已截止提交';
                        self.isDisabled = true;
                        return
                    }
                    const activityResult = JSON.parse(sessionStorage.getItem('activityResult'));
                    if( activityResult.isUsed === '0' && activityResult.continueFlag === '1') {
                        this.isContinue = true;
                    }else{
                        //来自自定义表单
                        sessionStorage.setItem("isFromCustomForm", '1');
                    }
                    // 站队成功，若开启了自动抽奖，且用户之前没有勾选过“不再询问”，则需要跳转授权页
                    if (this.automaticLottery === CFS.automaticLottery.open) {
                        this.subscribeNotification();
                    }
                } else {
                    let content = "活动过于火爆，请稍后再试";
                    if(r && r.message){
                        content = r.message;
                    }
                    self.isDisabled = false;
                    Toast(content);
                }
                this.reloadHandler();
                },
                failure:(err) => {
                    let content = "活动过于火爆，请稍后再试"
                    if(err && err.message){
                        content = err.message;
                    }
                    self.isDisabled = false;
                    Toast(content);
                    this.reloadHandler();
                }
            });
        },
        leftClickHandler() {
            if(!this.isLoginFlag){
                this.$utils.tips.message('warning', '登录后参与活动哦！');
                return;
            }
            this.side = "left";
            this.colorChosen = this.colorLeft;
            this.chooseSide = this.formShow.leftOfficialContent;
            const element = document.querySelector('.left-content');
            element.classList.add('animate__heartBeat');
            this.chooseSideFn(true)
        },
        rightClickHandler() {
            if(!this.isLoginFlag){
                this.$utils.tips.message('warning', '登录后参与活动哦！');
                return;
            }
            this.side = "right";
            this.colorChosen = this.colorRight;
            this.chooseSide = this.formShow.rightOfficialContent;
            const element = document.querySelector('.right-content');
            element.classList.add('animate__heartBeat');
            this.chooseSideFn(false)
        },
        // 如果登陆类型为微信登陆且未登陆，需要去对应小程序拉起登陆--暂时不用
        toGetMiniInfo(){
            if(!this.isLoginFlag && (this.loginType==='wechat' || this.loginType==='Alipay')){
                noLoginHandler(this.loginType, this.activityUrl)
                return;
            }
        },
        //初始化表单数据
        async initFormData(){
            //获取用户站队信息
            this.answer = JSON.parse(sessionStorage.getItem("answer")) ? JSON.parse(sessionStorage.getItem("answer")) : [];
            this.$api.post({
                noLoading: true,
                sc: "mobileMarketingH5",
                url:
                    "questionActivity/queryMiniActivityQuestionDetail/" + this.activityCode,
                     params:{
                            longitude: '',
                            dimension: ''
                         },
                success: r => {
                    const result = r.result || {};
                    if(r.result.activityStatus === "3")
                    {   
                        //活动已结束
                        this.showEnd = true;
                        this.disabled = true;
                        this.setClassLeft = "onlyReadLeft";
                        this.setClassRight = "onlyReadRight";
                        this.formShow.activityEndTimePop = result.activityEndTime.replace(/\-/g,'.');
                        this.formShow.activityStartTimePop = result.activityStartTime.replace(/\-/g,'.');
                    }
                    if(r.result.activityStatus === "0")
                    {
                        //活动未开始
                        this.showNoStart = true;
                        this.formShow.activityEndTimePop = result.activityEndTime.replace(/\-/g,'.');
                        this.formShow.activityStartTimePop = result.activityStartTime.replace(/\-/g,'.');
                    }
                    //  Left--正方   Right--反方
                    this.formCustom = result;
                    const tempBackground = result.activityTopicTemplateList[0];//获取背景图链接
                    const colorListL = result.questionList[0].optionList.filter(el => el.optionCode === "0");//正方按钮信息
                    const colorListR = result.questionList[0].optionList.filter(el => el.optionCode === "1");//反方按钮信息
                    this.activityCode = result.activityCode;//获取活动编码
                    // 对弹窗背景图链接兼容
                    if (tempBackground.topicTemplateBackgroundUrl) {
                        if (tempBackground.topicTemplateBackgroundUrl.indexOf("{") > -1) {
                            this.backgroundImg.topicTemplateBackgroundUrl = this.$utils.getImageUrl(
                                JSON.parse(tempBackground.topicTemplateBackgroundUrl).file
                            );
                        } else {
                            this.backgroundImg.topicTemplateBackgroundUrl= this.$utils.getImageUrl(
                             tempBackground.topicTemplateBackgroundUrl
                            );
                        }
                    }
                    // 对弹窗背景图链接兼容
                    if (tempBackground.topicTemplatePopUpUrl) {
                        if (tempBackground.topicTemplatePopUpUrl.indexOf("{") > -1) {
                            this.backgroundImg.topicTemplatePopUpUrl = this.$utils.getImageUrl(
                                JSON.parse(tempBackground.topicTemplatePopUpUrl).file
                            );
                        } else {
                            this.backgroundImg.topicTemplatePopUpUrl= this.$utils.getImageUrl(
                                tempBackground.topicTemplatePopUpUrl
                            );
                        }
                    }
                    this.formShow.activityEndTime = result.activityEndTime.split(" ")[0].replace(/\-/g,'.');//日期格式处理
                    this.formShow.activityStartTime = result.activityStartTime.split(" ")[0].replace(/\-/g,'.');
                    this.formShow.topicDesc = result.questionList[0].topicDesc;
                    this.colorLeft = colorListL[0].buttonColor;//正方按钮颜色
                    this.colorRight = colorListR[0].buttonColor;//反方按钮颜色
                    this.formShow.leftOfficialContent = result.questionList[0].optionList.filter(el => el.optionCode === "0")[0].officialContent;//正方站队文案
                    this.formShow.rightOfficialContent = result.questionList[0].optionList.filter(el => el.optionCode === "1")[0].officialContent;//反方站队文案
                    this.wordColor = colorListL[0].wordColor;//站队文案颜色
                    this.willUserHeadImgURl = result.willUserHeadImgURl;//正方站队头像
                    this.unWillUserHeadImgURl = result.unWillUserHeadImgURl;//反方站队头像
                    this.formShow.willRatio = result.willRatio ? result.willRatio : 0;//正方站队比例
                    this.formShow.unWillRatio = result.unWillRatio ? result.unWillRatio : 0;//反方站队比例
                    this.formShow.unWillNum = result.unWillNum ? result.unWillNum : 0;//正方站队人数
                    this.formShow.willNum = result.willNum ? result.willNum : 0;//反方站队人数
                    this.formShow.totalNum = Number(result.unWillNum + result.willNum);//总参与人数
                    this.automaticLottery = result.automaticLottery || '';
                    if (result.activityConfig) {
                        this.nextActivity = result.activityConfig.nextActivity;//下级页面
                        this.activityRules = result.activityConfig.ruleDescri || '';
                    }
                    if(result.activityGroup) {
                        this.bigWheelActivityType = result.activityGroup.bigWheelActivityType
                    }
                    // 有下级活动，且不开启自动开奖配置，才显示去抽奖按钮
                    if (this.nextActivity && this.automaticLottery !== CFS.automaticLottery.open) {
                        this.buttonShow = true;
                    }
                    if(this.formShow.willRatio === 0 && this.formShow.unWillRatio === 0){
                        //没人参与的时候两边都是0人，各占50%
                        this.formShow.willRatio = 50;
                        this.formShow.unWillRatio = 50;
                    }
                    if(this.answer.answerContent === "0"){
                        //用户已站队反方
                        this.isChosen = true;
                        this.colorChosen = this.colorLeft;
                        this.chooseSide = this.formShow.leftOfficialContent;
                        this.ratioChosen = this.formShow.willRatio;
                    }else if (this.answer.answerContent === "1"){
                        // 用户已站队反方
                        this.isChosen = true;
                        this.colorChosen = this.colorRight;
                        this.chooseSide = this.formShow.rightOfficialContent;
                        this.ratioChosen = 100 - this.formShow.willRatio;
                    }
                }
            })
        },
        goNextActivityFn() {
            // 配置的有下级页面，需要获取登陆信息跳转，以免还是展示立即登陆按钮
            // 父级页面信息
            const parentPageParams = {
                activityCode: this.nextActivity,
                parentPage: 'customForm_topicForm', 
                parentActivityCode: this.activityCode
            };
            const path = comUtils.appendParamsToURL(parentPageParams);
            this.$router.push({
                path: path
            })
        },
        reloadHandler() {
            this.$api.post({
                noLoading: true,
                sc: "mobileMarketingH5",
                url:
                    "questionActivity/queryMiniActivityQuestionDetail/" + this.activityCode,
                     params:{
                            longitude:this.positionInfo.longitude,
                            dimension:this.positionInfo.latitude
                         },
                success: r => {
                    const result = r.result || {};
                    // 重新获取活动的，站队人数、比例、用户头像等信息进行回显
                    this.formShow.willUserHeadImgURl = result.willUserHeadImgURl;
                    this.formShow.unWillUserHeadImgURl = result.unWillUserHeadImgURl;
                    this.formShow.willRatio = result.willRatio ? result.willRatio : 0;
                    this.formShow.unWillRatio = result.unWillRatio ? result.unWillRatio : 0;
                    this.formShow.unWillNum = result.unWillNum ? result.unWillNum : 0;
                    this.formShow.willNum = result.willNum ? result.willNum : 0;
                    this.formShow.totalNum = Number(result.unWillNum + result.willNum);
                    this.ratioChosen = this.side === "left" ? this.formShow.willRatio : this.formShow.unWillRatio;
                    this.sideNum = this.side === "left" ? this.formShow.willNum : this.formShow.unWillNum;
                    if(this.side === "left") {
                        this.imgList = this.formShow.willUserHeadImgURl;
                    }else if(this.side === "right"){
                        this.imgList = this.formShow.unWillUserHeadImgURl;
                    }
                    this.$nextTick(() => {
                        this.show = true;
                        this.isChosen = true;
                    })
                }
            })
        },
        //打开分享引导提示
        openGuide() {
            this.$refs.guideModal.openModel();
        },
        // 判断是否在小程序内
        handleMiniprogramJudge() {
        let that = this;
        if (this.loginType === "wechat") {
            //判断是否在微信小程序环境
            wx.miniProgram.getEnv(function (res) {
                if (res.miniprogram) {
                    that.miniprogramFlag = res.miniprogram;
                }
            });
        } else if (this.loginType === "Alipay") {
            loadAlipayWebViewScript().then(res => {
            if (res) {
                //判断是否运行在支付宝小程序环境里
                my.getEnv(function (res) {
                    if (res.miniprogram) {
                        that.miniprogramFlag = res.miniprogram;
                    }
                });
            }
            });
        }
        },
        showActivityRules() {
            this.$refs.activityRulesRef.show();
        },
        // 订阅抽奖结果通知
        subscribeNotification() {
            console.log('准备跳转拉起微信订阅授权===>')
            const reportInfo = [
                {
                alwaysFlag:'', // '订阅消息总是标识 0.总是 1.不是',此处传空就行 -- 此字段废弃，不再传给后台记录用户“总是保持以上选择”情况
                businessId: this.activityCode, //活动编码(话题PK的)
                businessType:'5', //活动类型
                templateId: '-qmw9U9rH8v49V0ODA0UA_a1y_NUWb7FUoJnb1pxDrM', //模板id
                }
            ]
            const needNotifyRewardsInfo = JSON.stringify(reportInfo);
            wx.miniProgram.navigateTo({
                url: `/subpackages/activity/pages/activityH5Notify/activity-h5-notify?bigWheelActivityType=${this.bigWheelActivityType}&needNotifyRewardsInfo=${needNotifyRewardsInfo}`
            });
        },
        // 查询当前用户是否已经授权过消息通知，且选择了“不再询问” --- 已废弃，每次都需要拉起订阅
        getUserSubscribeInfo() {
            const params = ['-qmw9U9rH8v49V0ODA0UA_a1y_NUWb7FUoJnb1pxDrM'];
            this.$api.post({
                params: params,
                sc: "mobileMarketing",
                url: "/miniActivityController/getUserAlwaysOptionByTemplateIdList",
                success: r => {
                    if (r && r.code === 200) {
                        const result = r.result || [];
                        if (result.includes('-qmw9U9rH8v49V0ODA0UA_a1y_NUWb7FUoJnb1pxDrM')) {
                            this.noAsk = true;
                        } else {
                            this.noAsk = false;
                        }
                    } else {
                        this.noAsk = false;
                    }
                },
                failure:(err) => {
                    let content = "活动过于火爆，请稍后再试"
                    if(err && err.message){
                        content = err.message;
                    }
                    Toast(content);
                }
            })
        }
    }
        
}
</script>

<style lang="scss" scoped>
.runtime-topic-pk {
    position:relative;
    width: 100%;
    height: 100vh;
    overflow: scroll;
    .content {
        width: 92%;
        padding: 3% 4%;
        background-color: #fff;
        border-radius: 10px;
        position:relative;
        top:36%;
        margin: 0 auto;
        .content-title {
            min-height: 24px;
            max-height: 48px;
            margin: 2% auto;
            span {
                font-family: HYQiHei-GZS;
                font-size: 18px;
                color: #333333;
                letter-spacing: 0;
                font-weight: 700;
            }
        }
        .content-time {
            margin: 2% auto -4% 0; 
            display: flex;
            justify-content: space-between;
            .time {
                width: 80%;
                height: 1.9%;
                span {
                    font-family: HYQiHei-EES;
                    font-size: 12px;
                    color: #999999;
                    letter-spacing: 0;
                    font-weight: 400;
                }
            }
            .share {
                height: 1.9%;
                display: flex;
                flex-direction: row;
                align-items: center;
                img {
                    width: 13.5px;
                    height: 13.5px;
                    margin-right: 3%
                }
                span{
                    width: 28px;
                    font-size: 12px;
                }
            }
        }
        .content-text {
            margin-top: -3%;
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
            span {
                font-family: HYQiHei-EES;
                font-size: 14px;
                color: #000000;
                letter-spacing: 0;
                line-height: 17px;
                font-weight: 400;
            }
        }
        .content-support {
            height: 10%;
            margin-top: 3.9%;
            display: flex;
            justify-content: space-between;
            .support-left {
                width: 22%;
                padding-top: 22%;
                border-radius: 50%;
                position: relative;
                .left-content {
                    .left-top {
                        >>>.van-icon {
                            font-size: 30px !important;
                        }
                    }
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .left-bottom {
                        color: #FFFFFF;
                        .left-bottom-text {
                            font-family: HYQiHei-FES;
                            font-size: 16px;
                            font-weight: 400;   
                        }
                    }
                }
            }
            .support-right {
                width: 22%;
                padding-top: 22%;
                border-radius: 50%;
                position: relative;
                .right-content{
                    .right-top {
                        >>>.van-icon {
                            font-size: 30px !important;
                        }
                    }
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .right-bottom {
                        color: #FFFFFF;
                        .right-bottom-text {
                            font-family: HYQiHei-FES;
                            font-size: 16px;
                            font-weight: 400;   
                        }
                    }
                }
            }
            .onlyReadLeft {
                width: 22%;
                padding-top: 22%;
                border-radius: 50%;
                position: relative;
                position: relative;
                pointer-events: none;
                .left-content{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .left-bottom {
                        color: #FFFFFF;
                        .left-bottom-text {
                            font-family: HYQiHei-FES;
                            font-size: 16px;
                            font-weight: 400;   
                        }
                    }
                }
            }
            .onlyReadRight {
                width: 22%;
                padding-top: 22%;
                border-radius: 50%;
                position: relative;
                position: relative;
                pointer-events: none;
                .right-content{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .right-bottom {
                        color: #FFFFFF;
                        .right-bottom-text {
                            font-family: HYQiHei-FES;
                            font-size: 16px;
                            font-weight: 400;   
                        }
                    }
                }
            }
            .support-content{
                width: 50%;
                >>>.van-progress {
                    height: 16% !important;
                }
                .support-content-top{
                    margin-top: 1%;
                    text-align: center;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    .percent-left {
                        width: 23%;
                        margin-right: 12%;
                        display: flex;
                        span {
                            font-size: 14px;   
                        }
                    }
                    .percent-right {
                        width: 23%;
                        margin-left: 12%;
                        display: flex;
                        span {
                            font-size: 14px;   
                        }
                    }
                    .PK {
                       font-size: 18px; 
                       font-weight: 1000;
                       font-style: italic;
                    }
                }
            }
        }
        .content-avatar {
            display: flex;
            justify-content: space-between;
            margin-top: 2.1%;
            margin-bottom: 2.4%;
            .left-container {
                width: 45%;
                margin-left: 1%;
                flex-direction: column;
                display: flex;
                align-items: center;
                margin-left: -12.85%;
                .avatar-left {
                    display: flex;
                    flex-direction: row;
                    height: 55%;
                    background-color: #FFFFFF;
                    margin-right: 2%;
                }
                .text-left {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                }
            }
           .right-container {
                width: 40%;
                flex-direction: column;
                display: flex;
                align-items: center;
                margin-right: -7.95%;
                .avatar-right {
                    display: flex;
                    flex-direction: row;
                    height: 55%;
                    background-color: #FFFFFF;
                }
                .text-right {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    span {
                        display: flex;
                        justify-content: flex-end;
                    }
                }
           }
        }
        .chosen-side {
            border-radius: 20px;
            margin-top: 3.2%;
            .stand-team {
                text-align: center;
                font-family: HYQiHei-FES;
                font-size: 16px;
                color: #FFFFFF;
                font-weight: 400;
                margin-bottom: 0.8%;
            }
            .container {
                height: 13.8vh;
                display: flex;
                justify-content: center;
                flex-direction: column;
                margin-bottom: 0.9%;
                .button {
                    width: 30%;
                    margin: 1.5% auto;
                    display: flex;
                    flex-direction: column;
                    >>>.van-button {
                        height: 32px !important;
                        width: 100% !important;
                        display: block !important;
                    }
                    span {
                        font-family: HONORSansBrand-DemiBold;
                        font-size: 14px;
                        font-weight: 600;
                    }
                }
            }
            .support-percent {
                text-align: center;
                font-family: HYQiHei-EES;
                font-size: 14px;
                color: #FFFFFF;
                font-weight: 400;
            }
        }
        .totalNum{
            display: flex;
            justify-content: center;
            margin-top: 5%;
            span {
                text-align: center;
                font-family: HYQiHei-EES;
                font-size: 12px;
                color: #999999;
                letter-spacing: 0;
                font-weight: 400;
            }
        }
    }
    
    .footer {
        width: 100%;
        position:fixed;
        bottom:3%; 
        display: flex;
        justify-content: center;
        span {
            font-family: HYQiHei-EES;
            font-size: 12px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            font-weight: 400;
        }
    }

    .activity-rules-area {
        position: absolute;
        top: -30px;
        right: -4vw;
        background-color: #fff;
        padding: 3px 6px;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        color: #315DD2;
    }
}

.dialog {
    width: 80%;
    padding: 38% 0 3% 0;
    border-radius: 15px;
    .dialog-content {
        padding: 3% 4% 8% 4%;
        position:relative;
        top:41%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .content-top {
            margin: 0 auto;
            span {
                font-family: HYQiHei-AZEJF;
                font-size: 18px;
                color: #315DD2;
                text-align: center;
                line-height: 44px;
                font-weight: 400;
            }
        }
        .content-middle {
            width: 68%;
             margin: 0 auto;
             margin-top: 5%;
             margin-left: 16%;
             display: flex;
             flex-direction: column;
             justify-content: center;
            .dialog-avatar {
                height: 40%;
                display: flex;
                flex-direction: row;
                justify-content: center;
            }
            span { 
                font-family: HONORSansBrand-Medium;
                font-size: 12px;
                color: #000000;
                letter-spacing: 0;
                font-weight: 700;
            }
        }
        .content-bottom{
            display: flex;
            justify-content: center;
            margin-top: 5%;
            .v-button {
                width: 50%;
                >>>.van-button {
                    height: 40px !important;
                    width: 100% !important;
                    display: block !important;
                }
            }
            
        }
        .share {
            height: 1.9%;
            display: flex;
            justify-content: center;
            flex-direction: row;
            align-items: center;
            margin-top: 2%;
            img {
                width: 13.5px;
                height: 13.5px;
                margin-right: 1%
            }
            span{
                width: 28px;
                font-size: 12px;
            }
        }
    }
}

.dialogEnd {
    position:relative;
    top: 9%;
    bottom: 27.2%;
    width: 80%;
    height: 45.5vh;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .endTitle {
        font-family: HYQiHei-FES;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        margin-bottom: 3.2%;
    }
    .endImage {
        display: flex;
        justify-content: center;
        margin-bottom: 4.8%;
        img {
            width: 50.3%;
        }
    }
    .activityTime {
        font-family: HYQiHei-EES;
        font-size: 14px;
        color: #999999;
        text-align: center;
        line-height: 23px;
        font-weight: 400;
    }

    
}

.noStart {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgb(255, 255, 255);
    height: 100%;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .top {
        font-family: HYQiHei-FES;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        margin-bottom: 3.2%;
    }
    .middle {
        display: flex;
        justify-content: center;
        margin-bottom: 4.8%;
        img {
            width: 42.3%;
        }
    }
    .bottom {
        display: flex;
        flex-direction: column;
        width: 87.2%;
        font-family: HYQiHei-EES;
        font-size: 14px;
        color: #999999;
        text-align: center;
        line-height: 23px;
        font-weight: 400;
    }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/topicPK.vue